import { AfterViewInit, ChangeDetectionStrategy, Component, Input, OnChanges, OnInit, ViewChild } from '@angular/core';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ModalDismissReasons, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { BehaviorSubject, takeUntil } from 'rxjs';
import { ViewerTemplate, SaveViewerTemplateRequest } from '../../models/media/vet-sale-template.model';
import { BaseUnsubscribeComponent } from '../../shared-new/components/base-unsubscribe/base-unsubscribe.component';
import { VetSettingsFacade } from '../../shared-new/store/vet-settings/vet-settings.facade';
import { Helper } from '../../utils/helper/helper';
import { ViewerTemplateCategoriesPopupComponent } from '../viewer-template-categories-popup/viewer-template-categories-popup.component';
import { VetSettingsDataSource } from './vet-settings-datasource';

@Component({
  selector: 'app-vet-settings',
  templateUrl: './vet-settings.component.html',
  styleUrls: ['./vet-settings.component.scss'],
})
export class VetSettingsComponent extends BaseUnsubscribeComponent implements OnInit{
  public isLoader: Boolean = false;

  viewerTemplates$ = this.vetSettingFacade.viewerTemplates$;
  public selectSaveViewerTemplates$ = this.vetSettingFacade.selectSaveViewerTemplates$;
  @ViewChild(MatSort) sort: MatSort;
  public dataSource: VetSettingsDataSource;
  public viewerTemplates: ViewerTemplate[];
  public allViewerTemplates: ViewerTemplate[];
  searchTerm: string;
  public closeResult = '';
  public displayedColumns$ = new BehaviorSubject([
    'name',
    'description',
    'categoryCount',
    'action'
  ]);
  constructor(private readonly vetSettingFacade: VetSettingsFacade, private readonly modalService: NgbModal) {
    super();
  }
  

  ngOnInit(): void {
    this.isLoader = true;
    this.vetSettingFacade.loadViewerTemplates();
    this.attachEvents();
  }

  trackByGroup(index: number, el: ViewerTemplate): number {
    return el.viewerTemplateId;
  }
  setAsDefault(template: ViewerTemplate) {
    this.isLoader = true;
    let saleTemplate: ViewerTemplate = {
      categoryCount: template.categoryCount,
      categoryIds: template.categoryIds,
      createdBy: template.createdBy,
      createdDate: template.createdDate,
      description: template.description,
      isActive: template.isActive,
      isDefault: true,
      memberId: template.memberId,
      name: template.name,
      //saleTemplateId: template.saleTemplateId,
      viewerTemplateId: template.viewerTemplateId
    }
    const request: SaveViewerTemplateRequest = {
      viewerTemplate: saleTemplate,
      viewerTemplateCategories: [],
      isUpdateOnlyDefault: true // it will be true when updating isDefault only
    };
    this.vetSettingFacade.saveViewerTemplate(request);
  }
  openSaleTemplateCategoriesPopup(template?: ViewerTemplate) {
    if (!template) {
      template = {
        //saleTemplateId: 0,
        name: '',
        description: '',
        createdBy: 0,
        memberId: 0,
        createdDate: new Date(),
        isActive: true,
        categoryCount: 0,
        categoryIds: [],
        isDefault: false,
        viewerTemplateId:0
      };
    }
    const modalRef = this.modalService.open(ViewerTemplateCategoriesPopupComponent, {
      ariaLabelledBy: template.viewerTemplateId + 'Id',
      centered: true,
      size: 'xl',
      keyboard: false,
      backdrop: 'static',
    });

    modalRef.componentInstance.data = { template: template };
    modalRef.result.then(
      (result) => {
        this.vetSettingFacade.loadViewerTemplates();
      },
      (reason) => {
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      }
    );
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }
  
  // Method to filter table data
  applyFilter(filterValue: string) {
    this.searchTerm = filterValue;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }
  public onTableScroll(): void {
    this.dataSource.onScroll();
  }
  private attachEvents() {
   
    this.viewerTemplates$.pipe(takeUntil(this.unsubscribe$)).subscribe((response) => {
      this.isLoader = false;
      this.dataSource = new VetSettingsDataSource(
        response,
        this.sort
      );
      if (this.searchTerm) {
        this.applyFilter(this.searchTerm);
      }
  });
    this.selectSaveViewerTemplates$.pipe(takeUntil(this.unsubscribe$)).subscribe((response) => {
      if (response) {
        this.isLoader = false;
        this.vetSettingFacade.handleClearState();
        this.vetSettingFacade.loadViewerTemplates();
      }
    });
  }
}
